<div class="row">
  @if (feeCategory(); as feeCategory) {
    <div class="col-12" style="padding-right: 1.5rem">
      @switch (true) {
        @case (contentUrl() === 'lokalizacja-przebudowa-zjazdu') {
          @if (isFiledByProxy()) {
            <app-alert [noIcon]="true" alertTittle="UWAGA!" [closable]="false">
              <div class="text-justify pt-2">
                W celu dokonania płatności online zostaniesz przeniesiony do nowej karty. <br> Po dokonaniu płatności
                należy
                dołączyć potwierdzenie przelewu:
                <a target="_blank"
                   title="Link otwierany w nowej zakładce przeglądarki"
                   routerLink="/login"
                   [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                  <strong>
                    Przejdź do płatności online
                  </strong>
                </a>
                <p class="mt-2">
                  Opłatę skarbową za pełnomocnictwo przedłożone w formie elektronicznej za pośrednictwem systemu
                  teleinformatycznego należy uiścić na konto organu podatkowego właściwego ze względu na miejsce
                  zamieszkania
                  lub siedzibę mocodawcy. W przypadku udzielenia pełnomocnictwa lub prokury przez więcej niż jednego
                  mocodawcę
                  w jednym dokumencie, właściwym organem jest organ podatkowy właściwy ze względu na miejsce
                  zamieszkania
                  albo
                  siedzibę mocodawcy wskazanego jako pierwszy, który ma miejsce zamieszkania albo siedzibę na terytorium
                  Rzeczypospolitej Polskiej. Należy samodzielnie ustalić właściwy organ podatkowy i wnieść opłatę na
                  jego
                  numer rachunku bankowego.
                  Prezydent Miasta stołecznego Warszawy jest właściwym organem, jeżeli mocodawca albo żaden z mocodawców
                  ustanawiających pełnomocnictwo lub prokurę w jednym dokumencie nie ma miejsca zamieszkania albo
                  siedziby
                  na
                  terytorium Rzeczypospolitej Polskiej.
                  W przypadku gdy miejsce zamieszkania lub siedziba mocodawcy znajduje się w mieście Dębica powołane
                  opłaty
                  skarbowe należy uiścić poprzez
                  <a target="_blank"
                     title="Link otwierany w nowej zakładce przeglądarki"
                     routerLink="/login"
                     [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                    <strong>Przejdź do płatności online</strong>
                  </a>
                  lub poza portalem na konto: Urząd Miejski w
                  Dębicy, ul. Ratuszowa 2, 39-200 Dębica, nr rachunku bankowego PEKAO S.A:
                  <strong>29 1240 4764 1111 0000 4863 34 19</strong>
                  <a
                    class="ms-2"
                    appCopyToClipboard="29 1240 4764 1111 0000 4863 34 19"
                    href="#" role="button">
                    <i aria-hidden="true" class="fa fa-copy"></i>
                    <span class="sr-only">Kopiuj numer konta do schowka</span>
                  </a>
                </p>
              </div>
            </app-alert>
          } @else {
            @if ((application()?.propertyUsagePurpose === 'Mieszkaniowy') && ['Nie ulegnie zmianie', 'Ulegnie zmianie na mieszkaniowy'].includes(application()?.postInvestmentUsage || '')) {

            } @else {
              <app-alert alertTittle="UWAGA!" [closable]="false">
                <div class="text-justify pt-1">
                  W celu dokonania płatności online zostaniesz przeniesiony do nowej karty. <br> Po dokonaniu płatności
                  należy
                  dołączyć potwierdzenie przelewu:
                  <a target="_blank"
                     title="Link otwierany w nowej zakładce przeglądarki"
                     routerLink="/login"
                     [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                    <strong>
                      Przejdź do płatności online
                    </strong>
                  </a>
                </div>
              </app-alert>
            }
          }
        }
        @default {
          @if (isFiledByProxy()) {
            <app-alert [noIcon]="true" alertTittle="UWAGA!" [closable]="false">
              <div class="text-justify pt-2">
                W celu dokonania płatności online zostaniesz przeniesiony do nowej karty. <br> Po dokonaniu płatności
                należy
                dołączyć potwierdzenie przelewu:
                <a target="_blank"
                   title="Link otwierany w nowej zakładce przeglądarki"
                   routerLink="/login"
                   [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                  <strong>
                    Przejdź do płatności online
                  </strong>
                </a>
                <p class="mt-2">
                  Opłatę skarbową za pełnomocnictwo przedłożone w formie elektronicznej za pośrednictwem systemu
                  teleinformatycznego należy uiścić na konto organu podatkowego właściwego ze względu na miejsce
                  zamieszkania
                  lub siedzibę mocodawcy. W przypadku udzielenia pełnomocnictwa lub prokury przez więcej niż jednego
                  mocodawcę
                  w jednym dokumencie, właściwym organem jest organ podatkowy właściwy ze względu na miejsce
                  zamieszkania
                  albo
                  siedzibę mocodawcy wskazanego jako pierwszy, który ma miejsce zamieszkania albo siedzibę na terytorium
                  Rzeczypospolitej Polskiej. Należy samodzielnie ustalić właściwy organ podatkowy i wnieść opłatę na
                  jego
                  numer rachunku bankowego.
                  Prezydent Miasta stołecznego Warszawy jest właściwym organem, jeżeli mocodawca albo żaden z mocodawców
                  ustanawiających pełnomocnictwo lub prokurę w jednym dokumencie nie ma miejsca zamieszkania albo
                  siedziby
                  na
                  terytorium Rzeczypospolitej Polskiej.
                  W przypadku gdy miejsce zamieszkania lub siedziba mocodawcy znajduje się w mieście Dębica powołane
                  opłaty
                  skarbowe należy uiścić poprzez
                  <a target="_blank"
                     title="Link otwierany w nowej zakładce przeglądarki"
                     routerLink="/login"
                     [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                    <strong>Przejdź do płatności online</strong>
                  </a>
                  lub poza portalem na konto: Urząd Miejski w
                  Dębicy, ul. Ratuszowa 2, 39-200 Dębica, nr rachunku bankowego PEKAO S.A:
                  <strong>29 1240 4764 1111 0000 4863 34 19</strong>
                  <a
                    class="ms-2"
                    appCopyToClipboard="29 1240 4764 1111 0000 4863 34 19"
                    href="#" role="button">
                    <i aria-hidden="true" class="fa fa-copy"></i>
                    <span class="sr-only">Kopiuj numer konta do schowka</span>
                  </a>
                </p>
              </div>
            </app-alert>
          }
        }
      }
    </div>
  }
</div>
